'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function LabelsModel(mapModel, labelGenerators) {
	let currentLabelGenerator;
	const self = observable(this),
		getContext = function () {
			return {
				labels: currentLabelGenerator
			};
		},
		dispatchContext = function () {
			const context = getContext();
			if (context) {
				self.dispatchEvent('context', context);
			}
		},
		setNodeLabels = function (labelGeneratorName) {
			if (currentLabelGenerator === labelGeneratorName) {
				mapModel.setLabelGenerator(false, labelGeneratorName);
				currentLabelGenerator = false;
			} else if (labelGeneratorName && labelGenerators[labelGeneratorName]) {
				currentLabelGenerator = labelGeneratorName;
				mapModel.setLabelGenerator(labelGenerators[labelGeneratorName], labelGeneratorName);
			} else {
				currentLabelGenerator = false;
				mapModel.setLabelGenerator(false, labelGeneratorName);
			};
			dispatchContext();
		};
	mapModel.addEventListener('labelGeneratorChange', function (labelGeneratorName, isSet) {
		if (isSet && labelGeneratorName && labelGenerators[labelGeneratorName]) {
			currentLabelGenerator = labelGeneratorName;
		} else {
			currentLabelGenerator = false;
		}
		dispatchContext();
	});
	Object.keys(labelGenerators).forEach(labelGenerator => {
		self[`toggle${labelGenerator}`] = () => setNodeLabels(labelGenerator);
	});
	self.deactivate = function () {
		if (currentLabelGenerator) {
			setNodeLabels(false);
		};
	};
};


